export default __webpack_public_path__ + "static/media/BrainBreak cards33.b5e55a09.png";